module.exports = __webpack_public_path__ + "static/media/4 Train-AP_Z2.bda78055.png";